<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap3">ISSUES AND ANSWERS</h1>
<p class="poem3" style="margin-top:30px;">Home of the brave, land of the free—</p>
<p class="poem3">I don’t want to be mistreated by no bourgeoisie.</p>
<p class="right">—“Bourgeois Blues,” a song by Huddie Ledbetter</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 7-chap3.vue?385afd7a